import { actionTypes } from '../actions/types';
import { SblStatusWeb } from '../generated-types';

type AppActions = import('../actions/types').AppActions;

export interface SblState {
    customerUrl: string | null;
    sblStatus: SblStatusWeb | null;
}

const initialState: SblState = {
    customerUrl: null,
    sblStatus: null,
};

export const SblReducer = (state = initialState, action: AppActions = {} as AppActions): SblState => {
    switch (action.type) {
        case actionTypes.FETCH_SBL_CONSENT_FULFILLED:
        case actionTypes.CREATE_SBL_CONSENT_FULFILLED: {
            return {
                ...state,
                customerUrl: action.payload?.customerUrl ?? null,
                sblStatus: action.payload?.sblStatus ?? null,
            };
        }

        case actionTypes.CREATE_SBL_CONSENT_FAILED:
        default:
            return state;
    }
};
